import { render, staticRenderFns } from "./file-formats.vue?vue&type=template&id=da3b2a50"
import script from "./file-formats.vue?vue&type=script&lang=js"
export * from "./file-formats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports